import { Box, Typography, Stack } from "@mui/material";

export default function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}) {
  return (
    <Box sx={{ mb: { xs: 2, md: 2.5 }, minWidth: 0 }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "stretch", sm: "center" }}
        justifyContent="space-between"
        gap={2}
        flexWrap="wrap"
        useFlexGap
        sx={{ "& > *": { minWidth: 0 } }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h5" sx={{ fontWeight: 700, fontSize: { xs: "1.25rem", sm: "1.5rem" } }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {actions ? (
          <Stack direction="row" gap={1} flexWrap="wrap" useFlexGap sx={{ flexShrink: 0, minWidth: 0, maxWidth: "100%" }}>
            {actions}
          </Stack>
        ) : null}
      </Stack>
    </Box>
  );
}
